import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-464d4e63"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "update-trigger-selector gap-x-10" }
const _hoisted_2 = {
  key: 3,
  class: "cm-align-center",
  style: {"color":"var(--cm-color-text-secondary)","font-size":"14px"}
}
const _hoisted_3 = {
  t: "1769580936931",
  class: "cm-ui-mr5",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "1629",
  width: "20",
  height: "20",
  style: {"fill":"var(--cm-color-text-secondary)"}
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z m0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z",
  "p-id": "1630"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M512 336m-48 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0Z",
  "p-id": "1631"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M536 448h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z",
  "p-id": "1632"
}, null, -1))
const _hoisted_7 = [
  _hoisted_4,
  _hoisted_5,
  _hoisted_6
]

import { ref, watch } from 'vue'
import { UpdateTrigger } from '../../ldap-sync-setting.service'


export default /*#__PURE__*/_defineComponent({
  __name: 'update-trigger-selector',
  props: {
    modelValue: {},
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const weekOptions = [
  { label: '周一', value: 1 },
  { label: '周二', value: 2 },
  { label: '周三', value: 3 },
  { label: '周四', value: 4 },
  { label: '周五', value: 5 },
  { label: '周六', value: 6 },
  { label: '周日', value: 7 }
]

const localTrigger = ref<UpdateTrigger>({
  type: props.modelValue.type || 2,
  start_time: props.modelValue.start_time || '09:00',
  week: props.modelValue.week || 1,
  day: props.modelValue.day || 1
})

watch(() => props.modelValue, (newVal) => {
  if (newVal) {
    localTrigger.value = {
      type: newVal.type || 2,
      start_time: newVal.start_time || '09:00',
      week: newVal.week || 1,
      day: newVal.day || 1
    }
  }
}, { deep: true, immediate: true })

const updateTrigger = () => {
  emit('update:modelValue', { ...localTrigger.value })
}

const handleTypeChange = () => {
  if (localTrigger.value.type === 3) {
    if (!localTrigger.value.week) {
      localTrigger.value.week = 1
    }
  } else if (localTrigger.value.type === 4) {
    if (!localTrigger.value.day) {
      localTrigger.value.day = 1
    }
  }
  updateTrigger()
}

const handleWeekChange = () => {
  updateTrigger()
}

const handleDayChange = () => {
  updateTrigger()
}

const handleTimeChange = () => {
  updateTrigger()
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_time_picker = _resolveComponent("el-time-picker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_select, {
      modelValue: localTrigger.value.type,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localTrigger.value.type) = $event)),
      placeholder: "请选择更新类型",
      size: "small",
      class: "trigger-select",
      disabled: _ctx.disabled,
      onChange: handleTypeChange
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_option, {
          label: "每小时",
          value: 1
        }),
        _createVNode(_component_el_option, {
          label: "每天",
          value: 2
        }),
        _createVNode(_component_el_option, {
          label: "每周",
          value: 3
        }),
        _createVNode(_component_el_option, {
          label: "每月",
          value: 4
        })
      ]),
      _: 1
    }, 8, ["modelValue", "disabled"]),
    (localTrigger.value.type === 3)
      ? (_openBlock(), _createBlock(_component_el_select, {
          key: 0,
          modelValue: localTrigger.value.week,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((localTrigger.value.week) = $event)),
          placeholder: "选择周",
          size: "small",
          class: "trigger-select",
          disabled: _ctx.disabled,
          onChange: handleWeekChange
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(weekOptions, (item) => {
              return _createVNode(_component_el_option, {
                key: item.value,
                label: item.label,
                value: item.value
              }, null, 8, ["label", "value"])
            }), 64))
          ]),
          _: 1
        }, 8, ["modelValue", "disabled"]))
      : _createCommentVNode("", true),
    (localTrigger.value.type === 4)
      ? (_openBlock(), _createBlock(_component_el_select, {
          key: 1,
          modelValue: localTrigger.value.day,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((localTrigger.value.day) = $event)),
          placeholder: "选择日期",
          size: "small",
          class: "trigger-select",
          disabled: _ctx.disabled,
          onChange: handleDayChange
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(31, (n) => {
              return _createVNode(_component_el_option, {
                key: n,
                label: `${String(n).padStart(2, '0')}日`,
                value: n
              }, null, 8, ["label", "value"])
            }), 64))
          ]),
          _: 1
        }, 8, ["modelValue", "disabled"]))
      : _createCommentVNode("", true),
    (localTrigger.value.type !== 1)
      ? (_openBlock(), _createBlock(_component_el_time_picker, {
          key: 2,
          modelValue: localTrigger.value.start_time,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((localTrigger.value.start_time) = $event)),
          format: "HH:mm",
          "value-format": "HH:mm",
          placeholder: "选择时间",
          size: "small",
          class: "trigger-time-picker",
          disabled: _ctx.disabled,
          onChange: handleTimeChange,
          style: {"max-width":"120px"}
        }, null, 8, ["modelValue", "disabled"]))
      : (_openBlock(), _createElementBlock("span", _hoisted_2, [
          (_openBlock(), _createElementBlock("svg", _hoisted_3, _hoisted_7)),
          _createTextVNode("每小时整点更新")
        ]))
  ]))
}
}

})